import axios, { AxiosInstance, AxiosResponse, AxiosError, InternalAxiosRequestConfig } from "axios";
import { message } from "antd";
import { MessageInstance } from "antd/es/message/interface"; // 默认使用静态方法，或者在初始化时赋值
import { refreshToken } from "./user";
import { clearStore, channelRoomStore } from "@obsbot/remo-stores";
export let globalMessageApi: MessageInstance = message;
let setSpin: ((isOpen: boolean) => void) | null = null;
let spinTimer: NodeJS.Timeout | null = null;
let reqRefreshTokenTimes = 0;

export const setIsOpenSpin = (controlSpin: (isOpen: boolean) => void): void => {
    setSpin = controlSpin;
};

export const setGlobalMessageApi = (api: MessageInstance): void => {
    globalMessageApi = api;
};

const white_list = ["/ums/v1/users/verification-codes", "/gcms/v1/conversation/emoji"];

// function createAxiosService(defaultHeaders: Record<string, string> = {}): AxiosInstance {
const service: AxiosInstance = axios.create({
    // baseURL: baseURL, // 您的 API 基础 URL
    timeout: 30 * 1000, // 请求超时时间
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
    },
});

// 请求拦截器
service.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        // 在发送请求之前做些什么
        // 例如：添加 token 到请求头
        // const token = localStorage.getItem("token");
        // if (token) {
        //     config.headers["Authorization"] = "Bearer" + token;
        // }
        // 500毫秒后如果还处于请求中，则显示加载中
        if (!white_list.some(item => config.url?.endsWith(item))) {
            spinTimer = setTimeout(() => {
                spinTimer && setSpin && setSpin(true);
            }, 300);
        }
        return config;
    },
    (error: AxiosError) => {
        if (spinTimer) {
            clearTimeout(spinTimer);
            spinTimer = null;
        }
        setSpin && setSpin(false);
        // 对请求错误做些什么
        console.error("Request Error:", error);
        return Promise.reject(error);
    },
);

let isRefreshing = false;
let requests: Function[] = [];

// 响应拦截器
service.interceptors.response.use(
    (response: AxiosResponse) => {
        if (spinTimer) {
            clearTimeout(spinTimer);
            spinTimer = null;
        }
        setSpin && setSpin(false);
        const t = (window as any).__ReMoI18n.t;
        // 对响应数据做些什么
        const res = response.data;
        // 如果业务状态码不是 200，则判断为错误
        // 您可以根据您的后端返回的实际状态码进行调整
        if (response.status === 200) {
            if (res.code) {
                const whiteCode = ["RM.0", "200", "RM.10036"];
                reqRefreshTokenTimes = 0;
                if (whiteCode.includes(res.code)) {
                    return res;
                } else if (
                    res.code === "RM.10032" &&
                    response.request.responseURL.includes("handle")
                ) {
                    return res;
                } else if (res.code === "RM.100119") {
                    // 用户注销报错，但是不需要提示
                    return Promise.reject(res);
                }
                console.log("[REQUEST DEBUG]报错", res, t("error_code." + res.code));
                globalMessageApi.error(t("error_code." + res.code));
                return Promise.reject(res || "Error");
            }
            return res;
        } else {
            console.error("Response Error:", res.msg || "Error", response);
            // switch()
            globalMessageApi.error(t("error_code." + res.code));
            // 这里可以根据不同的错误码进行不同的处理，例如：
            // 401: 未登录或登录过期
            // 403: 无权限
            // 500: 服务器内部错误
            // ...
            return Promise.reject(new Error(res.msg || "Error"));
        }
    },
    async (error: AxiosError) => {
        if (spinTimer) {
            clearTimeout(spinTimer);
            spinTimer = null;
        }
        console.log("request Error", error);
        setSpin && setSpin(false);
        const t = (window as any).__ReMoI18n.t;
        // 对响应错误做些什么
        const refresh_token = localStorage.getItem("refresh_token");
        const { config } = error;
        if (
            error.status === 401 &&
            refresh_token &&
            !config?.url?.includes("refresh-token") &&
            reqRefreshTokenTimes < 3
        ) {
            const originalConfig = config;
            if (isRefreshing) {
                return new Promise(resolve => {
                    requests.push((token: string) => {
                        originalConfig!.headers.Authorization = `Bearer ${token}`;
                        resolve(service(originalConfig!));
                    });
                });
            } else {
                isRefreshing = true;
                try {
                    const { token } = await refreshToken({
                        refresh_token,
                        client_type: (window as any).isElectron ? "game_client" : "web",
                    });
                    localStorage.setItem("token", token);
                    requests.forEach(cb => cb(token));
                    requests = [];

                    originalConfig!.headers.Authorization = `Bearer ${token}`;
                    return service(originalConfig!);
                } catch (error) {
                    console.log("[WEB] DEBUG RefreshToken更新失败", error);
                    localStorage.removeItem("token");
                    localStorage.removeItem("refresh_token");
                    return Promise.reject(error);
                } finally {
                    isRefreshing = false;
                    reqRefreshTokenTimes++;
                }
            }
        }
        const res: any = error.response?.data;
        // 拦截添加好友页面的错误代码返回，不展示通知弹窗
        if (config?.url?.endsWith("/gcms/v1/friend/add")) {
            const req = JSON.parse(config.data).blockMsgBox;
            if (req) {
                return Promise.reject(res);
            }
        }
        if (config?.url?.endsWith("/gcms/v1/channel/update")) {
            if (res.msg === "invalid parameters") {
                globalMessageApi.error(t("channel.limit-channel-min-count"));
                return Promise.reject(error);
            }
        }
        const tempCode = res?.error_code || res?.code;
        if (tempCode) {
            switch (error?.status) {
                case 401: {
                    // 未登录或登录过期
                    globalMessageApi.error(t("error_code." + tempCode));
                    window.location.hash = "#/login";
                    localStorage.removeItem("token");
                    localStorage.removeItem("refresh_token");
                    clearStore();
                    break;
                }
                case 403: {
                    // 无权限
                    globalMessageApi.error(t("error_code.RM.403"));
                    break;
                }
                case 404: {
                    // 请求资源不存在-自定义错误码
                    globalMessageApi.error(t("error_code.RM.404"));
                    break;
                }
                case 500: {
                    if (res.code === "RM.20004") {
                        channelRoomStore.leaveRoom();
                        globalMessageApi.error(t("error_code.RM.20004"));
                        break;
                    }
                    // 服务器内部错误
                    globalMessageApi.error(t("error_code.RM.500"));
                    break;
                }
                default: {
                    globalMessageApi.error(t("error_code." + tempCode));
                    break;
                }
            }
            return Promise.reject(res);
        }
        globalMessageApi.error(error.message);
        return Promise.reject(error);
    },
);

//     return service;
// }

// export default createAxiosService;
export default service;
